import { Module } from '../Module';

Module.instance().directive('tbUsernameInputValidator',
  () => {
    return {
      restrict: 'A',
      require: 'ngModel',
       link: (scope: ng.IScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {
        // this regex string requires double escaping, once for the string and once for the regex
        // it's matching the following chars: ; ,
        const USERNAME_REGEXP: RegExp = new RegExp('[;,]');

        ctrl.$parsers.push((inputName: any) => {
          ctrl.$setValidity('username', !USERNAME_REGEXP.test(inputName));
          return inputName;
        });
      }
    };
  }
);
